<template>
  <v-card>
    <v-card-title>Setting</v-card-title>
    <v-card-text>
      <v-form ref="form">
      <v-row>
        <v-col cols="6">
          <span class="v-label font-weight-bold">Application ID</span>
          <v-text-field
              outlined
              dense
              class="rounded-lg"
              flat
              solo
              v-model="currentApp.id"
              disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <span class="v-label font-weight-bold">Secret</span>
          <v-text-field
              :append-icon="showToken ? 'mdi-eye' : 'mdi-eye-off'"
              v-model="currentApp.token"
              outlined
              dense
              class="rounded-lg"
              flat
              solo
              :type="showToken ? 'text' : 'password'"
              @click:append="showToken = !showToken"
              :rules="formRules.required"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <span class="v-label font-weight-bold">Display name</span>
          <v-text-field
              outlined
              dense
              class="rounded-lg"
              flat
              solo
              v-model="currentApp.name"
              :rules="formRules.required"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <span class="v-label font-weight-bold">Description</span>
          <v-textarea
              outlined
              dense
              class="rounded-lg"
              flat
              solo
              v-model="currentApp.description"
              :rules="formRules.required"
          ></v-textarea>
        </v-col>
      </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn depressed class="text-none" color="primary" @click="submit">Update</v-btn>
      <v-btn depressed class="text-none" @click="cancel">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {sync} from "vuex-pathify";
import FormMixin from "@/mixins/form.mixin";
import {mapActions} from "vuex";

export default {
  name: "ApplicationSettings",
  mixins: [FormMixin],
  data() {
    return {
      showToken: false
    }
  },
  computed: {
    currentApp: sync('application/currentApp')
  },
  methods: {
    ...mapActions('application', ['updateWithoutConfirm']),
    submit() {
      if (this.$refs.form.validate()) {
        this.updateWithoutConfirm(this.currentApp)
      }
    },
    cancel() {
      this.currentApp = {};
      this.$router.push('/applications')
    }
  }
}
</script>

<style scoped>

</style>
